

export enum MigrationStatusEnum {
    STARTED = 1,
    PROGRESS = 2,
    COMPLETED = 100,
    FAILED = 99
}